import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Check } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, "Не удалось отправить запрос"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-page" className="mx-auto grid max-w-md px-4 py-16">
      <div className="rounded-3xl border border-line bg-white p-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Восстановление пароля</div>
        <h1 className="mt-2 text-3xl font-extrabold tracking-tightest text-ink">Забыли пароль?</h1>
        <p className="mt-2 text-sm text-muted">Введите email — мы отправим ссылку для смены пароля.</p>

        {!sent ? (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block">
              <span className="mb-1 block text-xs font-semibold text-muted">Email</span>
              <input
                required
                type="email"
                data-testid="forgot-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink"
              />
            </label>
            {error && (
              <div data-testid="forgot-error" className="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">{error}</div>
            )}
            <button
              data-testid="forgot-submit"
              disabled={busy}
              type="submit"
              className="w-full rounded-full bg-ink py-3 text-sm font-semibold text-white transition-colors hover:bg-ink-soft disabled:opacity-50"
            >
              {busy ? "Отправляем…" : "Отправить ссылку"}
            </button>
          </form>
        ) : (
          <div className="mt-8" data-testid="forgot-success">
            <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-success/10 text-success">
              <Check size={22} />
            </div>
            <p className="text-center text-sm text-ink">
              Если такой email зарегистрирован, мы отправили инструкцию.
            </p>
          </div>
        )}

        <div className="mt-6 text-center text-sm text-muted">
          <Link to="/login" className="font-semibold text-ink hover:underline">← Назад ко входу</Link>
        </div>
      </div>
    </div>
  );
}
